import Navbar from "./Navbar";
import AlumniEvents from "./Alumnus_Network/Alumni_Events";
import SuccessStories from "./Alumnus_Network/Success_Stories";
import Footer from "./Footer";
import './Css/Alumnus_Network.css';

function AlumnusNetwork() {
  return (
    <div>
      <Navbar />
      <AlumniEvents />
      <SuccessStories />
      <Footer />
    </div>
  );
}

export default AlumnusNetwork;